export let ButtonSize = /*#__PURE__*/function (ButtonSize) {
  ButtonSize["normal"] = "normal";
  ButtonSize["small"] = "small";
  ButtonSize["large"] = "large";
  return ButtonSize;
}({});
export let ButtonType = /*#__PURE__*/function (ButtonType) {
  ButtonType["button"] = "button";
  ButtonType["submit"] = "submit";
  ButtonType["reset"] = "reset";
  return ButtonType;
}({});